module.exports = __webpack_public_path__ + "static/media/success_small.62b87ac2.svg";